module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White-a2d3427feb493cbc88c11243b1feb0b0.png";